import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { PrimaryIconOutlineBtnLink } from "../component/OutlineBtn";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import { useFetchPlaylistQuery } from "../redux/rtk/YoutubeRTK";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./../styles/YoutubeVideoGrid.css";

export default function YoutubeVideoGrid() {
  const { data, error, isLoading } = useFetchPlaylistQuery();
  /* 
  const data = {
    kind: "youtube#playlistItemListResponse",
    etag: "QP8IW4lA9vDQlrcWBprPBT6TgVc",
    items: [
      {
        kind: "youtube#playlistItem",
        etag: "pn_9ZTCY5GzbiDw2tPA0VDcycBs",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci4zMDg5MkQ5MEVDMEM1NTg2",
        snippet: {
          publishedAt: "2026-03-10T09:58:10Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title:
            "IALM Student Testimonial: Certificate Course on Real Estate Laws",
          description:
            "In this video, IALM student Shourabh Gupta shares his experience and testimonial about the Certificate Course on Real Estate Laws. He talks about the course structure, key topics covered, and how the course helped him gain a better understanding of real estate laws and regulations.\n\nThis testimonial will help students and professionals who are interested in learning about real estate law and considering this course.\n\n#IALM #StudentTestimonial #RealEstateLaws #RealEstateLawCourse #LawCourse #LegalEducation #LawStudents #OnlineLawCourse #LawLearning #realestatelaws",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/gePgGOjtuWY/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/gePgGOjtuWY/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/gePgGOjtuWY/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/gePgGOjtuWY/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/gePgGOjtuWY/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 0,
          resourceId: {
            kind: "youtube#video",
            videoId: "gePgGOjtuWY",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "i9dB0-cnr4RCbWb1jGaVStQ_8lY",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci45ODRDNTg0QjA4NkFBNkQy",
        snippet: {
          publishedAt: "2026-03-10T09:53:01Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title: "IALM Student Testimonial: Corporate Security Laws Course",
          description:
            "In this video, IALM student Preeti Bansal shares her experience and testimonial about the Corporate Security Laws Course. She talks about the course content, learning experience, and how it helped her understand important aspects of corporate and security laws.\n\n#IALM #StudentTestimonial #CorporateSecurityLaws #LawCourse #LegalEducation #CorporateLaw #LawStudents #OnlineCourse #lawlearning",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/4VR1xjSmlIo/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/4VR1xjSmlIo/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/4VR1xjSmlIo/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/4VR1xjSmlIo/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/4VR1xjSmlIo/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 1,
          resourceId: {
            kind: "youtube#video",
            videoId: "4VR1xjSmlIo",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "E2Szdm8Zi9uGHBXukSN3mPUQfSU",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci40NzZCMERDMjVEN0RFRThB",
        snippet: {
          publishedAt: "2026-03-06T10:45:17Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title:
            "IALM Student Testimonial: Certificate in Professional Politics",
          description:
            "Watch this student testimonial for the Certificate in Professional Politics course at IALM. In this video, the student shares their learning experience and how the course helped them understand political systems, governance, and professional aspects of politics.\n\n#IALM #ProfessionalPolitics #PoliticsCourse #PoliticalStudies #Governance #PublicPolicy #StudentTestimonial #CourseReview #OnlineCourse #PoliticalEducation #LeadershipSkills #CareerInPolitics #OnlineLearning #PoliticalScience #skilldevelopmenttraining",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/0fMQOhOTUkM/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/0fMQOhOTUkM/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/0fMQOhOTUkM/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/0fMQOhOTUkM/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/0fMQOhOTUkM/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 2,
          resourceId: {
            kind: "youtube#video",
            videoId: "0fMQOhOTUkM",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "PEw9uTnpXbsfCpbx1IHzM4AHxD4",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci5GNjNDRDREMDQxOThCMDQ2",
        snippet: {
          publishedAt: "2026-03-06T10:29:41Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title:
            "IALM Student Testimonial: Certification in the Indian Constitution",
          description:
            "Watch this student testimonial for the Certification in the Indian Constitution course at IALM. In this video, the student shares their learning experience and how this course helped them understand the key principles and structure of the Indian Constitution.\n\n#IALM #IndianConstitution #ConstitutionalLaw #LawCourse #LegalEducation #LawStudents #OnlineLawCourse #IndianLaw #StudentTestimonial #CourseReview #LegalStudies #LawCareer #OnlineLearning #LegalTraining #LawCertification",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/qJlvzIw5zEQ/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/qJlvzIw5zEQ/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/qJlvzIw5zEQ/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/qJlvzIw5zEQ/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/qJlvzIw5zEQ/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 3,
          resourceId: {
            kind: "youtube#video",
            videoId: "qJlvzIw5zEQ",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "37wHJgSAOaXerZDQ-ZPciZyQdrk",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci45NDk1REZENzhEMzU5MDQz",
        snippet: {
          publishedAt: "2026-03-02T07:11:42Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title: "IALM Student Testimonial: Certificate Course in Cyber Laws",
          description:
            "Watch this student testimonial for the Certificate Course in Cyber Laws by IALM. The learner shares their experience of understanding cyber law concepts, digital regulations, and legal aspects of the online environment through this certification program.\n\n🎓 Course: Certificate Course in Cyber Laws\n🏛️ Institution: IALM\n\n#IALM #CyberLaw #CyberLawsCourse #StudentTestimonial #LawCourse #LegalEducation #CyberSecurityLaw #OnlineLawCourse #DigitalLaw #legalcareer",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/WYjBD5NC3bA/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/WYjBD5NC3bA/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/WYjBD5NC3bA/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/WYjBD5NC3bA/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/WYjBD5NC3bA/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 4,
          resourceId: {
            kind: "youtube#video",
            videoId: "WYjBD5NC3bA",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "T0o6NUuBsl59TYP2E70IRhoy-vk",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci5DQUNERDQ2NkIzRUQxNTY1",
        snippet: {
          publishedAt: "2026-03-02T07:07:03Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title:
            "IALM Student Testimonial: Professional Paralegal Certification",
          description:
            "Watch this student testimonial for the Professional Paralegal Certification course by IALM. Simran shares her experience of gaining practical legal knowledge and skills that support career growth in the legal field.\n\n🎓 Course: Professional Paralegal Certification\n🏛️ Institution: IALM\n\n#IALM #Paralegal #ParalegalCourse #ProfessionalParalegal #StudentTestimonial #LegalEducation #LawCourse #ParalegalTraining #OnlineLawCourse #legalcareer",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/Jy0xNYnUAfA/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/Jy0xNYnUAfA/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/Jy0xNYnUAfA/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/Jy0xNYnUAfA/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/Jy0xNYnUAfA/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 5,
          resourceId: {
            kind: "youtube#video",
            videoId: "Jy0xNYnUAfA",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "D5GGzTJW4urClwa8qGfpMKDqhK8",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci4xMkVGQjNCMUM1N0RFNEUx",
        snippet: {
          publishedAt: "2026-03-02T06:51:59Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title:
            "IALM Student Testimonial: Artificial Intelligence – Fundamentals to Applications",
          description:
            "Watch this student testimonial for the Artificial Intelligence – Fundamentals to Applications course by IALM. The learner shares their experience of understanding AI concepts and real-world applications through this certification program.\n\n🎓 Course: Artificial Intelligence – Fundamentals to Applications\n🏛️ Institution: IALM\n\n#IALM #ArtificialIntelligence #StudentTestimonial#IALM #ArtificialIntelligence #AICourse #StudentTestimonial #AIStudentReview #LearnAI #AICertification #OnlineCourse #AIForBeginners #TechSkills",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/e0IEz3BZU5E/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/e0IEz3BZU5E/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/e0IEz3BZU5E/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/e0IEz3BZU5E/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/e0IEz3BZU5E/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 6,
          resourceId: {
            kind: "youtube#video",
            videoId: "e0IEz3BZU5E",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "iDX-iBJeKc59d6-5VJzG7UpifeA",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci4wOTA3OTZBNzVEMTUzOTMy",
        snippet: {
          publishedAt: "2026-02-25T08:38:30Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title:
            "Become a Certified GST Practitioner with IALM! | Student Testimonial",
          description:
            "Are you looking to master the complexities of the Goods and Services Tax? Hear from our successful students about their journey in the GST Practitioner Certification Course at the International Academy of Law and Management (IALM).\n\n#gstpractitioner  #gstfiling  #ialmi  #taxconsultant  #indirecttax  #gstcertification  #commercestudentslife  #accountingskills  #legaleducation  #careergrowthtips",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/A1bi7_wre9Y/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/A1bi7_wre9Y/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/A1bi7_wre9Y/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/A1bi7_wre9Y/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/A1bi7_wre9Y/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 7,
          resourceId: {
            kind: "youtube#video",
            videoId: "A1bi7_wre9Y",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "SAwpSXN2ZkZ-SRYWAOoyrnRe1sA",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci41MjE1MkI0OTQ2QzJGNzNG",
        snippet: {
          publishedAt: "2026-02-25T08:36:48Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title: "At IALM, we don’t just teach. We transform careers. 🚀",
          description: "Listen to our students’ feedback.",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/XCcFbponqWs/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/XCcFbponqWs/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/XCcFbponqWs/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/XCcFbponqWs/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/XCcFbponqWs/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 8,
          resourceId: {
            kind: "youtube#video",
            videoId: "XCcFbponqWs",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "IHfRrnWBEG7gQOrKhxqW62OuOAI",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci4wMTcyMDhGQUE4NTIzM0Y5",
        snippet: {
          publishedAt: "2026-02-25T08:34:35Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title: "Become a GST Practitioner with IALM! | Student Testimonial",
          description:
            "From learning to leading – here’s what our students have to say about IALM. 🌟\nGST Practitioner Certification Course\n\n#gstpractitioner #gstfiling #ialmi #taxcompliance #commercestudentslife #legaleducationindia #GSTCertification#careergrowthtips #indirecttaxation #professionaldevelopment",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/FV2liGlfEh8/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/FV2liGlfEh8/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/FV2liGlfEh8/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/FV2liGlfEh8/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/FV2liGlfEh8/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 9,
          resourceId: {
            kind: "youtube#video",
            videoId: "FV2liGlfEh8",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "ycaTUkm2pTTRgFsjInVO5_BxVxk",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci4yODlGNEE0NkRGMEEzMEQy",
        snippet: {
          publishedAt: "2026-02-25T08:31:19Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title: "Student Testimonial | Master IPR Law & Procedure with IALM!",
          description:
            "Hear from Supriya Singhal as she shares her experience with the Advanced Certification Course on IPR Law & Procedure at the Indian Academy of Law and Management (IALM).\n\n#IPRLaw#intellectualpropertylaw #ialmi #legalcareers #lawstudent #IPRProcedure#careerdevelopment #onlinelawcourse #legalinternship #professionalcertification",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/Qs0CFMf7qIE/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/Qs0CFMf7qIE/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/Qs0CFMf7qIE/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/Qs0CFMf7qIE/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/Qs0CFMf7qIE/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 10,
          resourceId: {
            kind: "youtube#video",
            videoId: "Qs0CFMf7qIE",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "GT0uUiZmsj0-jpGKZOoxSeRFl3Y",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci41NkI0NEY2RDEwNTU3Q0M2",
        snippet: {
          publishedAt: "2026-02-25T08:28:14Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title:
            "IALM Student testimonial: Advanced Certification in Human Rights Law",
          description:
            "Real voices. Real experiences. Real growth. 🎓✨\nHear what our students say about their journey with IALM.\n\n#ialmi #humanrightslaw #LawCourse#LegalEducation#LawStudents#OnlineLawCourse\n#humanrights#LegalCareer#LawCertification#testimonialthursday#studentexperiences#onlinelearningcourse#LloydLawCollege",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/SO57LT6QGpM/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/SO57LT6QGpM/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/SO57LT6QGpM/hqdefault.jpg",
              width: 480,
              height: 360,
            },
            standard: {
              url: "https://i.ytimg.com/vi/SO57LT6QGpM/sddefault.jpg",
              width: 640,
              height: 480,
            },
            maxres: {
              url: "https://i.ytimg.com/vi/SO57LT6QGpM/maxresdefault.jpg",
              width: 1280,
              height: 720,
            },
          },
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 11,
          resourceId: {
            kind: "youtube#video",
            videoId: "SO57LT6QGpM",
          },
          videoOwnerChannelTitle: "IALM",
          videoOwnerChannelId: "UCrx6fkP1w-dmHkwRWpizJUw",
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "W-b7PPrz14neEEtxV0mNEmKdqV4",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci41MzJCQjBCNDIyRkJDN0VD",
        snippet: {
          publishedAt: "2026-03-02T06:56:19Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title: "Deleted video",
          description: "This video is unavailable.",
          thumbnails: {},
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 12,
          resourceId: {
            kind: "youtube#video",
            videoId: "ET6_5RPPF14",
          },
        },
      },
      {
        kind: "youtube#playlistItem",
        etag: "T3AtjGVkEmQe3g6vVPb5SdMyvTY",
        id: "UExvOUFGX0pBMk5hS2Q5b0t0b21Md3BRTmhndlZsbXNRci5EMEEwRUY5M0RDRTU3NDJC",
        snippet: {
          publishedAt: "2026-03-10T09:47:39Z",
          channelId: "UCrx6fkP1w-dmHkwRWpizJUw",
          title: "Deleted video",
          description: "This video is unavailable.",
          thumbnails: {},
          channelTitle: "IALM",
          playlistId: "PLo9AF_JA2NaKd9oKtomLwpQNhgvVlmsQr",
          position: 13,
          resourceId: {
            kind: "youtube#video",
            videoId: "-zQ9cJP8JD0",
          },
        },
      },
    ],
    pageInfo: {
      totalResults: 14,
      resultsPerPage: 50,
    },
  };
   */
  // console.log("Youtube data: ", data);

  const validVideos = data?.items?.filter(
    (v) =>
      v.snippet.title !== "Private video" &&
      v.snippet.title !== "Deleted video",
  );

  const [showAll, setShowAll] = useState(0);

  return (
    <section className="bg-lightaccent">
      <div className="container">
        <h2 className="sec-title text-center">Hear from our students</h2>
        <p className="sec-short-desc text-center">
          See what our students say about their experience & get the real
          feedback.
        </p>

        <div>
          <div className="row">
            {data && validVideos && (
              <_VideosGrid validVideos={validVideos} showAll={showAll} />
            )}
            {/* <_VideosGrid validVideos={validVideos} showAll={showAll} /> */}

            {isLoading && <_YoutubeVideoGridLoadingState />}

            {error && <div className="bg-danger">{JSON.stringify(error)}</div>}

            <div className="col-12 d-flex align-items-center justify-content-center">
              <button
                className={`btn btn-outline-primary theme-btn`}
                onClick={() => setShowAll(!showAll)}
              >
                {showAll == 0 ? "View All" : "Show less"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function _VideosGrid({ validVideos, showAll }) {
  return (
    <>
      {validVideos?.map((_item, index) => {
        return (
          <div
            className="col-md-6 col-lg-4 "
            style={{
              display: showAll == 0 && index > 5 ? "none" : "block",
            }}
          >
            <div
              className="card cc-style-1 mb-3 scale-on-hover shadow-on-hover"
              key={_item.snippet.resourceId.videoId}
            >
              <LiteYouTubeEmbed
                id={_item.snippet.resourceId.videoId}
                title={_item.snippet.title}
                poster="maxresdefault"
                lazyLoad={true}
                style={{ borderRadius: "16px", overflow: "hidden" }}
              />
            </div>
          </div>
        );
      })}
    </>
  );
}

function _YoutubeVideoGridLoadingState() {
  const items = new Array(6).fill("");
  return items.map((item, index) => {
    return (
      <div className="col-md-6 col-lg-4 " key={index}>
        <div className="card cc-style-1 mb-3 video-grid-loading-state"></div>
      </div>
    );
  });
}
